import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { AdministrationAddSortingCenterUserRoleForm, SortingCenter, SortingCenterUserRole } from 'types';
import { AppContext } from 'context';
import { transformObjectId } from 'services/apiPlatformTransformer';
import { AdministrationUserCreateStepProps } from './types';
import { AdministrationUserCreateStep5Schema } from './Step2.yup';
import { useStyles } from './styles';
import { DialogErrorSomeUserRoleNotSelected } from './DialogErrorSomeUserRoleNotSelected';
import LinkUserRolesTooltip from './UserRolesTooltip';
import ListItemSortingCenterUserRole from './ListItemSortingCenterUserRole';

export const Step2: React.FC<AdministrationUserCreateStepProps> = ({
  onSubmit,
  formName,
  previousStepData,
  formContext,
}) => {
  const context = useContext(AppContext);
  const classes = useStyles();
  const { t } = useTranslation('translation', { keyPrefix: 'administration.users.create' });
  const schema = useMemo(() => AdministrationUserCreateStep5Schema(t), [t]);

  const sortingCenterUserRoleInitial: string[] = [];
  formContext?.user?.sortingCenterUserRoles.map((sortingCenterUserRole: SortingCenterUserRole, index: number) => {
    const sortingCenterId = parseInt(transformObjectId(sortingCenterUserRole.sortingCenter), 10);
    sortingCenterUserRoleInitial[sortingCenterId] = sortingCenterUserRole.role;
    return null;
  });

  const defaultValues = {
    sortingCenterUserRole: sortingCenterUserRoleInitial,
  };

  const {
    clearErrors,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<AdministrationAddSortingCenterUserRoleForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: { ...previousStepData, ...defaultValues },
    resolver: yupResolver(schema),
  });

  const sortingCenters = context.getSortingCenters?.();
  const eligibleSortingCenter: SortingCenter[] = [];
  sortingCenters?.map((sortingCenterParent: SortingCenter, indexParent) => {
    eligibleSortingCenter.push(sortingCenterParent);
    sortingCenterParent.childrenSortingCenter?.map((sortingCenterChild: SortingCenter, indexChild) => {
      eligibleSortingCenter.push(sortingCenterChild);
      return null;
    });
    return null;
  });

  const [isOpenDialog, setIsOpenDialog] = useState(false);

  if (errors?.sortingCenterUserRole) {
    if (!isOpenDialog) setIsOpenDialog(true);
  }

  let listSortingCenterOnError: (SortingCenter | undefined)[] | undefined = [];
  if (isOpenDialog) {
    listSortingCenterOnError = getValues('sortingCenterUserRole')?.map((role: string, sortingCenterId: number) => {
      if (role || Boolean(sortingCenterUserRoleInitial[sortingCenterId])) {
        return undefined;
      }
      return eligibleSortingCenter.find(sortingCenter => transformObjectId(sortingCenter) === String(sortingCenterId));
    });
  }

  const handleCloseDialog = () => {
    clearErrors();
    setIsOpenDialog(false);
  };

  return (
    <>
      <DialogErrorSomeUserRoleNotSelected
        isOpen={isOpenDialog}
        setOpen={setIsOpenDialog}
        handleCancel={handleCloseDialog}
        listSortingCenterOnError={listSortingCenterOnError}
      />
      <form className={classes.form} id={formName} onSubmit={handleSubmit(onSubmit)}>
        <br />
        <LinkUserRolesTooltip />
        <br />
        <br />
        <div className={classes.divScrollRole}>
          {sortingCenters &&
            sortingCenters.map((sortingCenterParent: SortingCenter, index) => (
              <ListItemSortingCenterUserRole
                key={`sortingCenterParent.${index}`}
                sortingCenterParent={sortingCenterParent}
                previousStepData={previousStepData}
                formContext={formContext}
                sortingCenterUserRoleInitial={sortingCenterUserRoleInitial}
                control={control}
              />
            ))}
        </div>
      </form>
    </>
  );
};
